export default "__VITE_ASSET__DbXpxtSj__"